const ARTWORK_DATA_FILE_INPUT_FORM_FIELD_SUFFIX = 'files';
const ITEMS_COUNTER_SNIPPET = '<<frontSnippet(item_counter)>>';
const THUMBNAIL_SNIPPET = '<<frontSnippet(uploadedFileThumbnail)>>';
const PROGRESSBAR_SNIPPET = '<<frontSnippet(uploadProgressbar)>>';

const imageSizeErr = {
  'pl': 'Rozmiar zdjęcia jest za duży. Maksymalny rozmiar pliku ze zdjęciem to 10 MB. Spróbuj wgrać mniejszy plik.',
  'en': 'The image size is too large. The maximum file size for an image is 10 MB. Please try uploading a smaller file.',
  'de': 'Die Bildgröße ist zu groß. Die maximale Dateigröße für ein Bild beträgt 10 MB. Bitte laden Sie eine kleinere Datei hoch.',
  'es': 'El tamaño de la imagen es demasiado grande. El tamaño máximo del archivo de imagen es de 10 MB. Intenta subir un archivo más pequeño.',
  'fr': 'La taille de l’image est trop grande. La taille maximale d’un fichier image est de 10 Mo. Veuillez essayer de télécharger un fichier plus petit.',
  'ru': 'Размер изображения слишком большой. Максимальный размер файла изображения — 10 МБ. Попробуйте загрузить файл меньшего размера.',
};

const videoSizeErr = {
  'pl': 'Rozmiar wideo jest za duży. Maksymalny rozmiar pliku z wideo to 100 MB. Spróbuj wgrać mniejszy plik.',
  'en': 'The video size is too large. The maximum file size for a video is 100 MB. Please try uploading a smaller file.',
  'de': 'Die Videogröße ist zu groß. Die maximale Dateigröße für ein Video beträgt 100 MB. Bitte laden Sie eine kleinere Datei hoch.',
  'es': 'El tamaño del video es demasiado grande. El tamaño máximo del archivo de video es de 100 MB. Intenta subir un archivo más pequeño.',
  'fr': 'La taille de la vidéo est trop grande. La taille maximale d’un fichier vidéo est de 100 Mo. Veuillez essayer de télécharger un fichier plus petit.',
  'ru': 'Размер видео слишком большой. Максимальный размер файла видео — 100 МБ. Попробуйте загрузить файл меньшего размера.',
};

const fileSizeErr = {
  'pl': 'Rozmiar pliku jest za duży.',
  'en': 'The file size is too large.',
  'de': 'Die Dateigröße ist zu groß.',
  'es': 'El tamaño del archivo es demasiado grande.',
  'fr': 'La taille du fichier est trop grande.',
  'ru': 'Размер файла слишком большой.',
};

const requiredFieldsErr = {
  'pl': 'Nie wszystkie wymagane pola zostały uzupełnione. Uzupełnij brakujące pola i spróbuj ponownie.',
  'en': 'Not all required fields have been filled in. Please complete the missing fields and try again.',
  'de': 'Nicht alle Pflichtfelder wurden ausgefüllt. Bitte vervollständige die fehlenden Felder und versuche es erneut.',
  'es': 'No todos los campos obligatorios han sido completados. Por favor, completa los campos faltantes e inténtalo de nuevo.',
  'fr': 'Tous les champs obligatoires n\'ont pas été remplis. Veuillez compléter les champs manquants et réessayer.',
  'ru': 'Не все обязательные поля заполнены. Пожалуйста, заполните недостающие поля и попробуйте снова.',
};

const ARTWORK_REQUEST_ERRORS = {
  imageSizeErr,
  videoSizeErr,
  fileSizeErr,
  requiredFieldsErr,
}

export {
  ARTWORK_DATA_FILE_INPUT_FORM_FIELD_SUFFIX,
  ITEMS_COUNTER_SNIPPET,
  THUMBNAIL_SNIPPET,
  PROGRESSBAR_SNIPPET,
  ARTWORK_REQUEST_ERRORS,
}
